// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:07:33

export default {
  "id": "triple-sort-3d-home-design",
  "slug": "triple-sort-3d-home-design",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0cd9b933e1bc4b749615ebad5fb0933c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0cd9b933e1bc4b749615ebad5fb0933c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Triple Sort 3D Home Design",
      "description": "Welcome to the world of Triple Sort 3D: Home Design, where matching meets decorating! Dive in the puzzle-solving with and begin crafting a virtual space of your dreams. Get ready to transform ugly and cluttered rooms  into clean and cozy spaces! Discover the perfect blend of challenges, creativity, and an epic makeover journey that awaits you!",
      "instructions": "Find and tap 3 identical objects to complete the level",
      "genres": [
        "Match-3",
        "Merge"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-CN": {
      "title": "三维家居设计三重排序",
      "description": "欢迎来到“三重排序3D：家居设计”的世界：匹配即装饰！沉浸在解谜乐趣中，开始打造一个梦想中的虚拟空间。准备好将丑陋杂乱的房间转变为干净舒适的居住空间！发现充满挑战、创造力和史诗级改造旅程的完美融合，等待着你！",
      "instructions": "找到并点击3个相同的物品以完成关卡",
      "genres": [
        "匹配3",
        "合并"
      ],
      "tags": [
        "10x10（10x10）"
      ]
    },
    "zh-TW": {
      "title": "三重排序 3D 家居設計",
      "description": "歡迎進入《三重排序3D：家居設計》的世界：匹配即裝飾！投入解謎的樂趣中，開始打造一個屬於你的虛擬夢想空間。準備好將醜陋雜亂的房間變身為乾淨舒適的空間！探索挑戰、創意與傳奇改造之旅的完美融合，等待著您！",
      "instructions": "尋找並點擊3個相同的物件以完成等級",
      "genres": [
        "匹配3",
        "合併"
      ],
      "tags": [
        "10x10"
      ]
    },
    "zh-HK": {
      "title": "三重排序 3D 家居設計",
      "description": "歡迎進入「三合一排序3D：家居設計」的世界：配對遇見裝飾！沉浸在解謎樂趣中，開始打造一個夢幻的虛擬空間。準備將醜陋雜亂的房間變身為乾淨舒適的空間！發現挑戰、創意與經典變身之旅的完美結合，即將迎面而來！",
      "instructions": "尋找並點擊3個相同的物品以完成關卡",
      "genres": [
        "匹配3",
        "合併"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ja": {
      "title": "トリプルソート 3D ホームデザイン",
      "description": "トリプルソート3D：ホームデザインの世界へようこそ、マッチングとデコレーションが合わさった場所です！パズル解決に没頭し、夢のバーチャル空間を作り始めましょう！醜くて散らかった部屋をきれいで落ち着く空間に変える準備をしよう！挑戦と創造の絶妙なバランス、そしてあなたを待つ壮大なリノベーションの旅を発見しましょう！",
      "instructions": "3つ同じオブジェクトを見つけ、タップしてレベルを完了します。",
      "genres": [
        "マッチ3",
        "マージ"
      ],
      "tags": [
        "10x10"
      ]
    },
    "ko": {
      "title": "트리플 정렬 3D 홈 디자인",
      "description": "트리플 소트 3D: 홈 디자인의 세계에 오신 것을 환영합니다: 매칭과 장식이 만나는 곳! 퍼즐 해결에 몰입하여 꿈의 가상 공간을 만들기 시작하세요! 추잡하고 혼란스러운 방들을 깨끗하고 편안한 공간으로 변신시키기 위해 준비하세요! 도전, 창의성, 그리고 당신을 기다리는 경이적인 변신 여정을 발견하세요!",
      "instructions": "3 개의 동일한 물체를 찾아 터치하여 레벨을 완료하세요.",
      "genres": [
        "매치3",
        "합성"
      ],
      "tags": [
        "10x10"
      ]
    },
    "fr": {
      "title": "Triple Sort 3D Home Design\nTrio Tripler 3D Design de Maison",
      "description": "Bienvenue dans le monde de Triple Sort 3D : Décoration d'intérieur, où la correspondance rencontre la décoration ! Plongez dans le puzzle-solving et commencez à créer un espace virtuel de vos rêves. Préparez-vous à transformer des pièces laides et en désordre en espaces propres et accueillants ! Découvrez la parfaite combinaison de défis, de créativité et d'une aventure de transformation épique qui vous attend !",
      "instructions": "Trouvez et appuyez sur 3 objets identiques pour terminer le niveau.",
      "genres": [
        "Jeux de correspondance-3",
        "Fusion"
      ],
      "tags": [
        "10x10"
      ]
    }
  }
};
